import { createSlice } from "@reduxjs/toolkit";

export const activityActiveSlice = createSlice({
    name: 'activityActive',
    initialState: {
        value: undefined
    },
    reducers: {
        setActivityActive: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setActivityActive } = activityActiveSlice.actions;

export const getActivityActive = (state) => state.activityActive.value;

export default activityActiveSlice.reducer;